import { AutoFormFieldProps } from "@autoform/react";
import React from "react";
import CustomDateField from "@components/FormFields/CustomDateField";

export const DateField: React.FC<AutoFormFieldProps> = ({
  inputProps,
  error,
  id,
}) => {
  const { key, ...props } = inputProps;

  return (
    <CustomDateField
      id={id}
      className={error ? "border-destructive" : ""}
      {...props}
    />
  );
};
